import React, { ReactNode, Suspense } from "react"

import { LoadingIndicator } from "@axtesys/kassen-app-ui"

export function SuspenseProvider({ children }: { children: ReactNode }) {
  return <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
}
